import SensorProvider from '../providers/SensorProvider'

var SensorService = function () {
  return {
    GetSensorInformation: function (railobjectId) {
      return SensorProvider.GetSensorInformation(railobjectId)
    }
  }
}

export default new SensorService()



// WEBPACK FOOTER //
// ./src/services/SensorService.js